import { PaneTopology } from "./Pane/Pane";

/**
 * Full-page topologies
 */
export default [
  // TODO: Replace with some 'page' topology
  undefined,
  PaneTopology,
];
